import React, { useEffect, useState } from "react";
import GoKeggStyle from "./gokegg.module.css";
import { UploadOutlined } from "@ant-design/icons";
import {
  Form,
  Select,
  Radio,
  Input,
  Upload,
  Button,
  Col,
  Row,
  InputNumber,
  Tabs,
  Table,
  Tooltip,
  Carousel,
} from "antd";
import { ReactComponent as DownloadIcon } from "../../../assets/icon/下载.svg";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import GenomeNewList from "./json/Genome";
import http from "../../../utils/http";
import styled from "styled-components";
const { TextArea } = Input;
const contentStyle = {
  margin: 0,
  textAlign: "center",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  height: "600px",
};
// 定义Styled组件来修改走马灯指示点的样式
const StyledCarousel = styled(Carousel)`
  .slick-dots li button {
    background-color: #ccc; /* 默认指示点颜色 */
    border-radius: 50%; /* 圆形 */
    width: 10px;
    height: 10px;
    opacity: 1;
  }

  .slick-dots li.slick-active button {
    background-color: #2e8b9e; /* 激活状态指示点颜色 */
  }

  .slick-dots li button:hover {
    background-color: #f0a500; /* 悬浮时的颜色 */
  }
`;

function GoKegg() {
  const [form] = Form.useForm();
  const [fileContent, setFileContent] = useState("");
  const [IsSubmit, setIsSubmit] = useState(false);
  const [GoKeggTable, setGoKeggTable] = useState([]);
  const [GoKeggImgs, setGoKeggImgs] = useState([]);
  const [gokeggPdf,setGoKeggPdf]=useState({})
  const [pdfUrls, setPdfUrls] = useState({});
  const [Colums, setColums] = useState([]);
  const [IsTabs, setIsTabs] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0); // 当前轮播图索引
  const onFinish = (value) => {
    setIsSubmit(true);
    const newFormData = new FormData();
    const TempleObject = {
      comp_species: value.Genome,
      comp_type: value.method,
      gene_list: value.gene_id_text,
      yuzhi_p: value.p,
      yuzhi_q: value.q,
    };

    Object.keys(TempleObject).forEach((key) => {
      newFormData.append(key, TempleObject[key]);
    });

    http
      .post("/api/tools/enrich/", newFormData)
      .then((res) => {
        console.log(
          res.kegg_data && res.kegg_data.length !== 0 ? "KEGG" : "GO"
        );
        setIsTabs(true);
        setIsSubmit(false);
        const createPdfUrl = (base64Data) => {
          const byteCharacters = atob(base64Data);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: 'application/pdf' });
          return URL.createObjectURL(blob);
        };
   // 处理所有返回的PDF数据
   const pdfData = res.kegg_pdf || res.go_pdf;
   const urls = {};
   Object.entries(pdfData).forEach(([key, value]) => {
     urls[key] = createPdfUrl(value);
   });

   setPdfUrls(urls);
        // KEGG 数据处理
        if (res.kegg_data && res.kegg_data.length !== 0) {
          console.log("KEGG");
          setGoKeggTable(res.kegg_data);
          let TempleColums = [];
          Object.keys(res.kegg_data[0]).map((key) => {
            TempleColums.push({
              title: key,
              dataIndex: key,
              key: key,
              align: "center",
              render: (index, item) => {
                if (key == "geneID") {
                  return (
                    <Tooltip title={index}>
                      <p
                        className={GoKeggStyle.GeneID}
                        style={{ width: "200px" }}
                      >
                        {index}
                      </p>
                    </Tooltip>
                  );
                }
                if (key == "Hyperlink") {
                  return (
                    <Tooltip
                      title={
                        <a href={index} target="_blank">
                          {index}
                        </a>
                      }
                    >
                      <p
                        className={GoKeggStyle.GeneID}
                        style={{ width: "200px" }}
                      >
                        <a href={index} target="_blank">
                          {index}
                        </a>
                      </p>
                    </Tooltip>
                  );
                }
                return <p>{index}</p>;
              },
            });
          });
          setColums(TempleColums);
          let templeArrimg = [];
          Object.keys(res.kegg_png).map((key) => {
            if (typeof res.kegg_png === "object") {
              templeArrimg.push({
                key: key,
                name: key.split("_").join(" "),
                url: res.kegg_png[key],
              });
            }
          });
          console.log(templeArrimg);
          setGoKeggImgs(templeArrimg);
          let templeArrpdf = [];
          Object.keys(res.kegg_pdf).map((key) => {
            if (typeof res.kegg_pdf === "object") {
              templeArrpdf.push({
                key: key,
                name: key.split("_").join(" "),
                url: res.kegg_pdf[key],
              });
            }
          });
          setGoKeggPdf(templeArrpdf)
        }

        // GO 数据处理
        if (res.go_data && res.go_data.length !== 0) {
          console.log("GO");
          console.log(res);
          setGoKeggTable(res.go_data);
          let TempleColums = [];
          Object.keys(res.go_data[0]).map((key) => {
            TempleColums.push({
              title: key,
              dataIndex: key,
              key: key,
              align: "center",
              render: (index, item) => {
                if (key == "geneID") {
                  return (
                    <Tooltip title={index}>
                      <p
                        className={GoKeggStyle.GeneID}
                        style={{ width: "200px" }}
                      >
                        {index}
                      </p>
                    </Tooltip>
                  );
                }
                return <p>{index}</p>;
              },
            });
          });
          setColums(TempleColums);

          let templeArrimg = [];
          Object.keys(res.go_png).map((key) => {
            if (typeof res.go_png === "object") {
              templeArrimg.push({
                key: key,
                name: key.split("_").join(" "),
                url: res.go_png[key],
              });
            }
          });
          console.log(templeArrimg);
          setGoKeggImgs(templeArrimg);
          let templeArrpdf = [];
          Object.keys(res.go_pdf).map((key) => {
            if (typeof res.go_pdf === "object") {
              templeArrpdf.push({
                key: key,
                name: key.split("_").join(" "),
                url: res.go_pdf[key],
              });
            }
          });
          setGoKeggPdf(templeArrpdf)
        }
      })
      .catch((err) => {
        console.error("Error occurred: ", err); // 打印错误
        setIsSubmit(false);
      });
  };

  const [MethodValue, setMethodValue] = useState(1);
  const onChange = (e) => {
    setMethodValue(e.target.value);
  };

  const contentUpload = (file) => {
    const reader = new FileReader();
    reader.onload = (event) => {
      const content = event.target.result;
      setFileContent(content);
    };
    reader.readAsText(file);
    return false; // 阻止默认上传行为
  };
  useEffect(() => {
    form.setFieldsValue({
      gene_id_text: fileContent,
    }); // 初始化时更新文本域的值
  }, [fileContent]);
  const [pValue, setPValue] = useState(null);
  const [qValue, setQValue] = useState(null);
  const [isPDisabled, setIsPDisabled] = useState(false);
  const [isQDisabled, setIsQDisabled] = useState(false);
  const handlePChange = (value) => {
    setPValue(value);
    // 当 P 值不为空时禁用 Q 输入框
    if (value !== null && value !== 0) {
      setQValue(null);
      setIsQDisabled(true);
    } else {
      setIsQDisabled(false);
    }
  };

  const handleQChange = (value) => {
    setQValue(value);
    // 当 Q 值不为空时禁用 P 输入框
    if (value !== null && value !== 0) {
      setPValue(null);
      setIsPDisabled(true);
    } else {
      setIsPDisabled(false);
    }
  };
  const onChangeTabs = (key) => {
    console.log(key);
  };
  const onChangeSwiper = (currentSlide) => {
    console.log(currentSlide);
    setCurrentIndex(currentSlide);
  };

  // CSV 转换函数
  function convertToCSV(jsonData) {
    if (!jsonData || jsonData.length === 0) {
      return "";
    }

    const columns = Object.keys(jsonData[0]);
    let csvString = columns.join(",") + "\n";

    jsonData.forEach((row) => {
      let rowString = columns
        .map((column) => {
          let value = row[column];
          if (
            typeof value === "string" &&
            (value.includes(",") || value.includes("\n") || value.includes('"'))
          ) {
            value = `"${value.replace(/"/g, '""')}"`; // 替换双引号为两个双引号
          }
          return value;
        })
        .join(",");
      csvString += rowString + "\n";
    });

    return csvString;
  }

  // 文件下载函数
  function downloadCSV(csvString, filename) {
    const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = filename || "data.csv"; // 设置文件名
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
  const handleDownloadCSV = () => {
    if (GoKeggTable.length === 0) {
      alert("No data to download");
      return;
    }

    // 从表单中获取 Genome 的值
    const genomeValue = form.getFieldValue("Genome");

    // 如果 Genome 值为空，使用默认文件名
    const filename = genomeValue ? `${genomeValue}.csv` : "table_data.csv";

    // 将表格数据转换为 CSV 字符串
    const csvString = convertToCSV(GoKeggTable);

    // 触发文件下载
    downloadCSV(csvString, filename);
  };
  const downloadAllPdfsAsZip = async () => {
    const zip = new JSZip(); // 创建一个 ZIP 实例
  
    // 创建一个 Promise 数组
    const promises = gokeggPdf.map(async (item) => {
      // 检查 item.url 是否存在
      if (!item.url) {
        console.error(`Missing URL for item: ${item.name}`);
        return;
      }
  
      // 提取 Base64 数据部分并移除前缀
      const base64Data = item.url.split(',')[1];
  
      // 检查 base64Data 是否存在
      if (!base64Data) {
        console.error(`Invalid Base64 data for item: ${item.name}`);
        return;
      }
  
      // 清理 Base64 数据并补齐长度
      const cleanedBase64 = base64Data.replace(/[^A-Za-z0-9+/=]/g, '');
      const paddingLength = (4 - cleanedBase64.length % 4) % 4;
      const validBase64 = cleanedBase64 + '='.repeat(paddingLength);
  
      // 将 Base64 转换为 Blob 对象
      const blob = base64ToBlob(validBase64, "application/pdf");
  
      // 将 Blob 转换为 ArrayBuffer
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          const arrayBuffer = e.target.result;
          zip.file(item.name, arrayBuffer); // 将文件添加到 ZIP 中
          resolve();
        };
        reader.onerror = (e) => {
          console.error(`Error reading file: ${item.name}`, e);
          reject();
        };
        reader.readAsArrayBuffer(blob); // 使用 FileReader 将 Blob 转换为 ArrayBuffer
      });
    });
  
    // 等待所有文件处理完成
    await Promise.all(promises);
  
    // 生成 ZIP 文件并触发下载
    zip.generateAsync({ type: "blob" }).then((content) => {
      saveAs(content, "all-pdfs.zip"); // 下载名为 "all-pdfs.zip" 的文件
    });
  };
  const downloadZip = async () => {
    try {
      const zip = new JSZip();
      
      for (const [name, url] of Object.entries(pdfUrls)) {
        const response = await fetch(url);
        const blob = await response.blob();
        const fileName = `${name.replace(/[\s()]/g, '_')}.pdf`;
        zip.file(fileName, blob);
      }

      const content = await zip.generateAsync({ type: "blob" });
      saveAs(content, "analysis_plots.zip");
    } catch (error) {
      console.error("下载出错：", error);
      alert("下载失败，请重试");
    }
  };
  // 将 Base64 转换为 Blob 对象
  const base64ToBlob = (base64, contentType) => {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: contentType });
  };
  const items = [
    {
      key: "1",
      label: "Images",
      children: (
        <div>
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              marginBottom: "10px",
            }}
          >
            <Button
           onClick={downloadZip}
            >
              <DownloadIcon width={20} /> <span>Download</span>
            </Button>
          </div>
          {/* data:image/png;base64, */}
          <StyledCarousel afterChange={onChangeSwiper}>
            {GoKeggImgs.map((item, index) => {
              return (
                <div>
                  <h3 style={contentStyle}>
                    <img
                      id={`chart-${index}`} // 为每张图片设置唯一的 ID
                      src={`data:image/png;base64,${item.url}`}
                      style={{ width: "27%" }}
                      alt=""
                    />
                    <p>{item.name}</p>
                  </h3>
                </div>
              );
            })}
          </StyledCarousel>
        </div>
      ),
    },
    {
      key: "2",
      label: "Table Data",
      children: (
        <div>
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              marginBottom: "10px",
            }}
          >
            <Button onClick={handleDownloadCSV}>
              <DownloadIcon width={20} /> <span>Download</span>
            </Button>
          </div>
          <Table
            columns={Colums}
            bordered
            dataSource={GoKeggTable}
            rowKey={"id"}
            scroll={{
              x: true,
            }}
          />
        </div>
      ),
    },
  ];

  return (
    <div className={GoKeggStyle.GoKegg_app}>
      <div className={GoKeggStyle.GoKegg_Header}>
        <p>GO/KEGG enrichment</p>
      </div>
      <div className={GoKeggStyle.GoKegg_Form}>
        <Form
          form={form}
          onFinish={onFinish}
          style={{
            margin: "20px auto",
            padding: "20px",
          }}
          initialValues={{
            method: 1,
            p: 0.05,
          }}
        >
          <Form.Item
            name="Genome"
            label={<span style={{ fontWeight: "bold" }}>Genome</span>}
            rules={[
              {
                required: true,
                message: "Please select Genome",
              },
            ]}
          >
            <Select options={GenomeNewList} />
          </Form.Item>
          <Form.Item
            name="method"
            label={<span style={{ fontWeight: "bold" }}>Method</span>}
            rules={[
              {
                required: true,
                message: "Please select Method",
              },
            ]}
          >
            <Radio.Group onChange={onChange} value={MethodValue}>
              <Radio value={1}>GO</Radio>
              <Radio value={2}>KEGG</Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item
            name="gene_id_text"
            label={<span style={{ fontWeight: "bold" }}>Gene List</span>}
            rules={[
              {
                required: true,
                message: "Please input Gene List",
              },
            ]}
          >
            <TextArea style={{ height: 150 }} />
          </Form.Item>
          <Form.Item
            colon={false}
            label={<span style={{ color: "transparent" }}>Gene List</span>}
            name="SN"
            style={{
              width: "60%",
            }}
          >
            <Upload
              beforeUpload={contentUpload}
              name="SN"
              action="/upload.do"
              onRemove={() => {
                setFileContent("");
              }}
            >
              <Button
                style={{
                  border: "none",
                  padding: "0",
                  margin: "0",
                  background: "transparent",
                }}
                icon={<UploadOutlined />}
              >
                Click to upload
              </Button>
            </Upload>
          </Form.Item>
          <Row>
            <Col span={14}>
              <Form.Item
                name="p"
                label={
                  <p
                    style={{
                      fontWeight: "bold",
                      textAlign: "center",
                      padding: "0",
                      margin: "0",
                    }}
                  >
                    <span>Threshod</span>
                    <span>
                      (<i>P</i>-value or FDR)
                    </span>
                  </p>
                }
              >
                <InputNumber
                  style={{ width: "100%" }}
                  min={0}
                  max={1}
                  step={0.01}
                  value={pValue}
                  onChange={handlePChange}
                  disabled={isPDisabled}
                />
              </Form.Item>
            </Col>
            <Col span={10} style={{ padding: "0 10px" }}>
              <Form.Item name="q">
                <InputNumber
                  style={{ width: "100%" }}
                  min={0}
                  max={1}
                  step={0.01}
                  value={qValue}
                  onChange={handleQChange}
                  disabled={isQDisabled}
                />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item
            colon={false}
            label={<span style={{ color: "transparent" }}>Gene List</span>}
          >
            <Button
              style={{
                color: "#67C23A",
                border: "none",
                fontWeight: "bold",
              }}
              onClick={() => {
                form.setFieldsValue({
                  Genome: "NNU",
                  method: 1,
                  gene_id_text: `Chr01.g06113.m1
Chr01.g03923.m1
Chr01.g05207.m1
Chr01.g05800.m2
Chr01.g02317.m1
Chr01.g04118.m1
`,
                });
                setMethodValue(1);
              }}
            >
              example
            </Button>
          </Form.Item>
          <Form.Item
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Button
              style={{
                margin: "0 10px",
                background: "#67C23A",
                border: "none",
                color: "white",
              }}
              htmlType="submit"
              loading={IsSubmit}
            >
              Submit
            </Button>
            <Button
              style={{ border: "1px solid #6C5E6E", color: "#6C5E6E" }}
              onClick={() => {
                form.resetFields();
                setIsTabs(false);
              }}
            >
              Reset
            </Button>
          </Form.Item>
        </Form>
      </div>
      {IsTabs ? (
        <Tabs
          defaultActiveKey="1"
          style={{ width: "95%", margin: "0 auto" }}
          items={items}
          onChange={onChangeTabs}
        />
      ) : (
        ""
      )}
      <div style={{ height: "40px" }}></div>
    </div>
  );
}

export default GoKegg;
